export enum Page {
    Packages,
    Frames,
    Corners,
    Confirm,
}

